export enum REGENERATE_SECRETS_STEPS {
  'INFO' = 'INFO',
  'OTP_VERIFICATION' = 'OTP_VERIFICATION',
  'NEW_SECRETS' = 'NEW_SECRETS'
}

export enum OTP_VERIFICATION_TYPE {
  'EMAIL_SMS_USSD' = 'EMAIL_SMS_USSD',
  'EMAIL_SMS' = 'EMAIL_SMS'
}

export enum BUSINESS_ERRORS {
  'INCORRECT_OTP' = 'INCORRECT_OTP',
  'ORDER_NOT_FOUND' = 'ORDER_NOT_FOUND',
  'OTP_EXPIRED' = 'OTP_EXPIRED',
  'OTP_DELIVERY_FAILURE' = 'OTP_DELIVERY_FAILURE'
}

export interface OtpValue {
  smsOtp: string;
}
